export default "__VITE_ASSET__Zr5l5cXG__"